// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"53d91cc1","787":"46d15545","850":"d937d1f0"}[chunkId] + ".chunk.js";
};